module.exports = __webpack_public_path__ + "img/V28.d0b7d3e0.jpg";